<template>
    <div class="container-center">

        <el-form class="notice-form" label-width="140px" ref="form" :model="form" :rules="rules">
            <el-row>
                <el-col :span="10">
                    <el-form-item label="年份：" prop="yearMark">
                        <el-input size="medium" v-model="form.yearMark" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="2" :offset="1">
                    <el-button type="warning" class="btn-theme" size="medium" @click="getNoticeList" icon="el-icon-search">搜索</el-button>
                </el-col>
            </el-row>
        </el-form>


        <div class="notice-list-box">
            <div class="no-data-tip" v-if="noticeList.length == 0"></div>
            <div v-else class="notice-list" v-for="li in noticeList" :key="li.id">
                <p class="title" @click="getDetail(li.id)">{{ `${li.yearMark} ${li.productName}` }}</p>
                <p class="date">{{ li.issueDate && li.issueDate.substring(0,10) }}</p>
            </div>
        </div><!-- .notice-list-box -->


        <div class="block">
            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="pager.pageSize"
                :current-page="pager.pageNo"
                :total="pager.total"
                prev-text="上一页"
                next-text="下一页"
                layout="total, prev, pager, next"
                background
                >
            </el-pagination>
        </div>


        <el-dialog :title="dialogTitle" :visible.sync="dialogFlag" width="800px" center>
            <div class="main-row-middle">
                <div class="middle-row" v-for="item in dialogData.detailList" :key="item.id">
                    <div class="left-div">
                        <i class="iconfont icon-paiming"></i>
                        <span class="middle-row-text">{{ item.supplierName }}</span>
                    </div>
                    <div class="right-div active">{{ item.evaluateLevel }}</div>
                </div>
            </div>
            
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogFlag = false">关 闭</el-button>
            </span>

        </el-dialog>

    </div><!-- container-center -->
</template>

<script>
import banner from '@/assets/imgs/banner_invite.png'
import filter from '@/filter'

export default {
    name: 'notice-list',
    data () {
        return {
            rules: {

            },
            noticeList: [],

            form: {
                yearMark: ''
            },

            pager:{
                total: 0,
                pageNo: 1,
                pageSize: 10
            },
            dialogData: {
            },
            dialogFlag: false,
            dialogTitle: ''
        }
    },
    methods: {
        getNoticeList () {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    // this.submitForm()
                    this.$http.post('/rest/api/dsp/sysevas/yearList',
                        {
                            pageNo: this.pager.pageNo,
                            pageSize: this.pager.pageSize,
                            yearMark: this.form.yearMark
                        }
                    ).then((res)=>{
                        if(res.data.result) {
                            this.noticeList = res.data.value.list;
                            this.pager.total = res.data.value.count;
                            this.pager.pageNo = res.data.value.pageNo;
                        }
                    })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        handleCurrentChange (page) {
            this.pager.pageNo = page;
            this.getNoticeList();
        },
        getDetail (id) {
            this.$http.get(`/rest/api/dsp/sysevas/yearDetail/${id}`).then((res)=>{
                if(res.data.result) {
                    this.dialogData = res.data.value
                    let productArray = this.dialogData.productName.split('_')
                    this.dialogTitle = `${this.dialogData.yearMark}${productArray[productArray.length -1]}`

                    this.dialogFlag = true
                }
            })
        },
    },
    created(){
        this.$root.navs = [{name:'供方履约公告',path:'/peSupplierList'}];
        this.$root.headImage.src = banner;
    },
    mounted () {
        this.getNoticeList();
    }
}

</script>

<style scoped lang="postcss">
@import '../../../assets/common.css';

.clearfix:after {display: table;content: " ";clear: both;}

.notice-form {background: #F5F6F5;padding: 25px 10px 10px 10px;margin: 24px 0;}

.notice-list {width: 100%;height: 48px;border-bottom: 1px solid #E4E5E4;}
.notice-list > p {font-size: 16px;margin:0;line-height: 48px;}
.notice-list > p.title {float: left;width: 1000px;font-weight: bold; cursor:pointer;}
.notice-list > p.title a {color: #000;text-decoration: none; }
.notice-list > p.title a:hover {color: var(--cMain);}
.notice-list .date {float: right;}

.main-row-middle .middle-row{
    overflow: hidden;
    margin-bottom: 14px;
}
.main-row-middle .middle-row:last-child{
    margin-bottom: 0;
}
.main-row-middle .middle-row .left-div{
    float: left;
    width: calc(100% - 30px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 22px;
    height: 22px;
    cursor: pointer;
}
.main-row-middle .middle-row:hover{
    background-color: #f7f7f7;
}
.main-row-middle .middle-row .left-div .icon-paiming{
    font-size: 14px;
    color: #EE7D42;
    margin-right: 5px;
}
.main-row-middle .middle-row .left-div .middle-row-text{
    font-size: 14px;
    color: #333333;
}
.main-row-middle .middle-row:hover .middle-row-text{
    color: #EE7D42;
}
.main-row-middle .middle-row .right-div{
    float: right;
    color: #333333;
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
    height: 22px;
}
.main-row-middle .middle-row .right-div.active{
    color: #EE7D42;
}
</style>



// WEBPACK FOOTER //
// src/pages/dsp/notice/SysYearList.vue